import {url} from "../utilities";
import * as $ from "jquery";
import axios from "axios";
import Spinner from "../spinner";
import {toastAlert} from "../toastAlert";
import {confirmModal} from "../confirmModal";
import {enableFormBack} from "../forms";


export const sms_page = () => {
    $("#smsHistoryTable").DataTable({
        stateSave: false,
        order: [0, 'desc'],
        filters: {
            columns: [
                {
                    index: 2,
                    title: 'Operacja'
                }
            ]
        }
    });

    let smsDetailsTable = $("#smsDetailsTable").DataTable({
        order: [1, 'asc'],
        stateSave: false,
        columnDefs: [
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ],
        drawCallback: function() {
            this.$('.status-info').each(function() {
                new bootstrap.Tooltip(this, {html: true});
            })
        },
    });

    $(".detailsButton").click(async function () {
        let id = $(this).data('id');
        let response = await axios.get(url(`api/associations/sms/details?id=${id}`));
        let sms = response.data.sms;

        let modalDOM = document.getElementById("smsDetails");

        let modalInstance = bootstrap.Modal.getInstance(modalDOM);
        if (!modalInstance) {
            modalInstance = new bootstrap.Modal(modalDOM);
        }
        modalInstance.show()


        smsDetailsTable.DataTable().api().rows().remove().draw();

        $(".full-content").html(sms.content);

        for (let receiver of sms.receivers) {
            if (parseInt(receiver.status) === 1) {
                receiver.status = 'W kolejce';
            } else if (parseInt(receiver.status) === 2) {
                receiver.status = 'Wysłano';
            } else {
                receiver.status = 'Błąd';
            }

            let row = $(`
            <tr>
                <td>${receiver.user.first_name}</td>
                <td>${receiver.user.last_name}</td>
                <td>${receiver.phone_number}</td>
            </tr>
        `);

            let td;
            if(receiver.status === 'Błąd') {
                td = $(`<td>${receiver.status} <i class="fas fa-info-circle text-primary status-info" data-bs-target="tooltip" title="${receiver.status_info}"></i></td>                <td>${receiver.amount}</td>
`);
            }else{
                td = $(`<td>${receiver.status}</td><td>${receiver.amount}</td>
`);
            }

            row.append(td);

            $("#smsDetailsTable tbody").append(row);
            smsDetailsTable.DataTable().api().rows.add(row).draw();
        }

    });

    let charsLeft = $("#charactersLeft");
    let smsCounter = $("#smsCounter");
    let messageBox = $("#addTextMessage_content");

    let standard_chars = "@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà\r ";
    let double_chars = "^{}\\[~]€\n|";

    let normalCharSet = [160, 306, 459, 612];
    let specialCharSet = [70, 134, 201, 268];


    messageBox.keyup(function () {

        let hasSpecials = false;
        let content = messageBox.val();
        let content_array = content.split('');

        let char_count = 0;

        let char_left = 0;
        let sms_count;
        let max_char;
        for(let char of content_array)
        {
            if(standard_chars.includes(char)){
                char_count += 1;
            }else if (double_chars.includes(char)){
                char_count += 2;
            }else{
                char_count += 1;
                hasSpecials = true;
            }
        }

        if(hasSpecials === true){
            if(char_count <= 268 ) {
                let i = 1;
                for (let set of specialCharSet) {
                    if (set >= char_count) {
                        max_char = set;
                        break;
                    }
                    i++;
                }
                charsLeft.removeClass('text-danger')
                sms_count = i;
            }else{
                char_left = -1;
                charsLeft.addClass('text-danger');
                sms_count = -1;
            }
        }else{
            if(char_count <= 612) {
                let i = 1;
                for (let set of normalCharSet) {
                    if (set >= char_count) {
                        max_char = set;
                        break;
                    }
                    i++;
                }
                charsLeft.removeClass('text-danger')
                sms_count = i;
            }else{
                char_left = -1;
                charsLeft.addClass('text-danger');
                sms_count = -1;
            }
        }

        if(sms_count === -1 || char_left === -1){
            charsLeft.html("Przekroczono limit znaków!");
            smsCounter.html(0);
        }else{
        charsLeft.html(max_char - char_count);
        smsCounter.html(sms_count);
        }

    });

    $("#placeOrder").click(function () {
        let tariff = $("#orderSMS_amount").find('option:selected').val();
        let contactMailForm = $("#orderSMS_contact_email").val();
        let tariffType = $("#tariffType");
        let tariffPrice = $("#tariffPrice");
        let contactMail = $("#contactMail");

        if (parseInt(tariff) === 2000) {
            tariffType.html(2000);
            tariffPrice.html("280 zł netto");
        } else if (parseInt(tariff) === 4000) {
            tariffType.html(4000);
            tariffPrice.html("520 zł netto");
        } else if(parseInt(tariff) === 8000) {
            tariffType.html(8000);
            tariffPrice.html("1000 zł netto");
        } else if(parseInt(tariff) === 1000){
            tariffType.html(1000);
            tariffPrice.html("145 zł netto");
        }

        contactMail.html(contactMailForm);

    });

    $("#confirmTerms").change(function () {
        $("#confirmOrderBtn").toggleClass('disabled');
    })

    $("#confirmOrderBtn").click(function () {
        let form = $("#orderSMS");
        form.submit();
    })

    $("form#addTextMessage").submit(async function(e) {
        e.preventDefault();

        const spinner = new Spinner();


        try {
            const response = await axios.post(url(`api/sms/validate`), $(this).serialize());

            if(response.data.code !== 200) {
                throw new Error();
            }

            spinner.destroy();
            if(response.data.numbers && response.data.numbers.invalid && response.data.numbers.invalid.length > 0) {
                let send = await confirmModal(
                    `Wybrano przynajmniej jeden niepoprawny numer: <br /><br />` +
                    `${response.data.users.map(u => `- ${u.phone_number} (${u.display_name})`).join('<br />')} <br /><br />` +
                    `Czy chcesz wysłać wiadomość pomijając niepoprawne numery?`,
                    {title: 'Znaleziono niepoprawne numery'}
                )

                if(send) {
                    for(let user of response.data.users) {
                        $(this).find(`input[name="to[]"][value="${user.id}"]`).remove()
                    }

                    this.submit();
                } else {
                    enableFormBack(this);
                }
                return;
            }

            this.submit();
        } catch(err) {
            spinner.destroy();
            toastAlert('Wystąpił błąd podczas próby wysłania wiadomości. Spróbuj ponownie później.', {type: 'danger'});
        }
    })
}
